import { MinusCircleOutlined } from "@ant-design/icons";
import { Button, Form } from "antd";
import { useState } from "react";
import { ApplicantUserCitizenship, ApplicantUserUpdateInput } from "../../../../generated";
import { Country } from "../../../../types/country";
import { EditProfile } from "./edit-profile";
import { CountryDropdownContainer } from "../../../shared/country-dropdown/country-dropdown-container";

const EDIT_TITLE = "View Citizenship Details";

interface ApplicantProfileCitizenshipEditProps {
  citizenship: ApplicantUserCitizenship | null | undefined;
  countries: Country[];
  onCancel: () => void;
  onSave: (applicant: ApplicantUserUpdateInput) => Promise<void>;
}

export const ApplicantProfileCitizenshipEdit: React.FC<ApplicantProfileCitizenshipEditProps> = ({
  citizenship,
  countries,
  onCancel,
  onSave,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [form] = Form.useForm<ApplicantUserUpdateInput & { currentCitizenOf?: string[] }>();

  const initialValues = {
    currentCitizenOf: citizenship?.currentCitizenOf,
  };

  const selectedCitizenship = Form.useWatch<string[]>("currentCitizenOf", form);

  const CitizenshipDetialsForm = (
    <Form
      form={form}
      initialValues={initialValues}
      layout="vertical"
      onFinish={async (values) => {
        onSave(values);
        setIsSubmitting(true);
      }}
    >
      <Form.Item label="Current Citizen of" name="currentCitizenOf">
        <Form.List name="currentCitizenOf">
          {(fields, { add, remove }) => (
            <div>
              {fields.map((field) => (
                <div key={field.key} style={{ marginBottom: "15px" }}>
                  <div
                    style={{
                      display: "inline-block",
                      verticalAlign: "top",
                      paddingRight: "10px",
                    }}
                  >
                    <MinusCircleOutlined
                      className="dynamic-delete-button"
                      onClick={() => {
                        remove(field.name);
                      }}
                    />
                  </div>
                  <div
                    style={{
                      display: "inline-block",
                      paddingTop: "3px",
                      paddingLeft: "10px",
                      borderLeft: "1px solid darkgrey",
                    }}
                  >
                    <Form.Item
                      {...field}
                      validateTrigger={["onChange", "onBlur"]}
                      rules={[
                        {
                          required: true,
                          message: "Please select field or delete this field.",
                        },
                      ]}
                    >
                      <CountryDropdownContainer
                        isCitizenship={true}
                        placeholder="Country"
                        style={{ width: 200 }}
                        showSearch
                        countryData={countries}
                        selectedCitizenship={selectedCitizenship}
                        labelRender={(labelInValue) => {
                          const country = labelInValue ? countries.find((c) => c.countryCode === (labelInValue.value as string)) : null;
                          return country ? <span>{country.countryName}</span> : null;
                        }}
                        onChange={(value: string) => {
                          form.setFieldValue(["currentCitizenOf", field.name], value);
                        }}
                      />
                    </Form.Item>
                  </div>
                </div>
              ))}
              {fields.length < 5 ? (
                <Form.Item>
                  <Button
                    type="dashed"
                    onClick={() => {
                      const currentCitizenOf = form.getFieldValue(["currentCitizenOf"]);
                      if (currentCitizenOf?.some((val: string) => val === undefined)) return;
                      add();
                    }}
                    block
                    style={{ width: 500, paddingRight: "10px" }}
                  >
                    Add Additional Citizenship
                  </Button>
                </Form.Item>
              ) : null}
            </div>
          )}
        </Form.List>
      </Form.Item>

      <div className="flex items-center justify-center gap-4 w-full">
        <Button onClick={onCancel} disabled={isSubmitting}>
          Cancel
        </Button>
        <Button htmlType="submit" value={"save"} style={{ background: "#3F4373", color: "#D9D9D9" }} loading={isSubmitting}>
          Save
        </Button>
      </div>
    </Form>
  );

  return <EditProfile title={EDIT_TITLE} form={CitizenshipDetialsForm} />;
};
